import toast from 'react-hot-toast';
import useApi from '../useApi';
import {ManualTimerRequest,ManualTimerRes} from "./index.type";

const useManualTimer = ({ patientId, clinicId }: { patientId: string, clinicId: string }) => {
    const url = `/rtm/timer/manual-entry?associatedClinicianId=${clinicId}&patientId=${patientId}`;
    const method = 'POST';
    const { loading: StartManualTimerLoading, makeApiCall } = useApi({ url, method });
  
    const StartManualTimer = async (formData: ManualTimerRequest) => {
      const { response, error } = await makeApiCall<ManualTimerRequest, ManualTimerRes>(formData);
      
      if (response?.status === 'success') { toast.success('Time Added successfully');
        return response;
      }
  
      if (error || !response?.status) {
        toast.error(error?.msg || 'Failed to update timer. Please try again.');
        return { status: 'fail' } as ManualTimerRes;
      }
    };
  
    return {
      StartManualTimerLoading,
      StartManualTimer,
    };
  };

export default useManualTimer ;
